import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, Loader } from 'ncoded-component-library';
import CurrentUserEnquiryContextContext from 'providers/CurrentUserEnquiryContext/CurrentUserEnquiryContext.context';
import { getIsArrayEmpty } from 'utils';
import PlusIcon from 'icons/Plus.icon';
import AddEnquiryContextModal from './components/AddEnquiryContextModal';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import EnquiryContextInstance from './components/EnquiryContextInstance';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './UserEnquiryContextContainer.styles.scss';
import './UserEnquiryContextContainer.styles.responsive.scss';

type UserEnquiryContextContainerProps = {
  className?: string;
};

const UserEnquiryContextContainer: React.FC<
  UserEnquiryContextContainerProps
> = (props) => {
  const { className } = props;

  const [editId, setEditId] = useState('');

  const { isSuperAdmin } = useContext(CurrentUserContext);
  const { isLoading, userEnquiryContext, getIsLoading } = useContext(
    CurrentUserEnquiryContextContext,
  );

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  const classes = classNames('user-enquiry-context-container', className);

  const { t } = useTranslation();

  if (isSuperAdmin) return null;

  return (
    <div className={classes}>
      <div className="user-enquiry-context-container__heading">
        <p className="title">{t('enquiryContext')}</p>
        <Button icon={PlusIcon} onClick={modal?.open}>
          {t('addContext')}
        </Button>
      </div>

      <p className="user-enquiry-context-container__description">
        {t('enquiryContextDescription')}
      </p>

      {isLoading ? (
        <Loader />
      ) : getIsArrayEmpty(userEnquiryContext) ? (
        <div className="user-enquiry-context-container__empty-state">
          <p>{t('enquiryContextEmptyStateNote1')}</p>
          <p>{t('enquiryContextEmptyStateNote2')}</p>
        </div>
      ) : (
        userEnquiryContext.map((context) => (
          <EnquiryContextInstance
            key={context._id}
            context={context}
            isLoading={getIsLoading(context._id)}
            isEdit={editId === context._id}
            onEdit={() => setEditId(context._id)}
            onCancel={() => setEditId('')}
          />
        ))
      )}

      <AddEnquiryContextModal ref={modalRef} />
    </div>
  );
};

export default UserEnquiryContextContainer;
